// extracted by mini-css-extract-plugin
export default {"text-hoa":"news_text-hoa__07qcx","news_internet-tele__txt":"news_news_internet-tele__txt__OmLIJ","title-tt":"news_title-tt__b1CFo","img":"news_img__SqfyQ"};